import { Step, StepLabel, Stepper } from '@mui/material';
import React from 'react';
import { StepperIcon } from './StepperIcon';
export const BigScreenHeader = ({ step, stepLabels }) => {
    return (React.createElement(Stepper, { activeStep: step, sx: {
            mt: 2,
            display: 'flex',
            flexWrap: {
                xs: 'wrap',
                md: 'nowrap',
            },
            justifyContent: 'center',
            '& .MuiStepConnector-root': {
                display: 'none',
            },
        } }, stepLabels.map((label, index) => {
        const active = index === step;
        const completed = index < step;
        return (React.createElement(Step, { key: label, sx: {
                flex: {
                    xs: '1 0 50%',
                    md: '1 0 auto',
                },
                mb: '1em',
                alignItems: 'center',
            } },
            React.createElement(StepLabel, { sx: {
                    pt: 2,
                    minWidth: '230px',
                    borderTop: '1px solid',
                    borderColor: (theme) => active || completed ? theme.palette.primary.main : theme.palette.grey[400],
                }, slots: { stepIcon: StepperIcon } }, label)));
    })));
};
